import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusTrackerComponent } from './status-tracker/status-tracker.component';
import {MaterialModule} from "../shared/material.module";
import {SectionStatusService} from "./section-status.service";
import {FlexLayoutModule} from "@angular/flex-layout";

@NgModule({
  declarations: [
    StatusTrackerComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule
  ],
  exports: [
    StatusTrackerComponent,
  ],
  providers: [SectionStatusService]
})

export class StatusTrackerModule { }
